import React from 'react';
import { Grid, Typography } from '@mui/material';
import NewsCard from './NewsCard';
import image1 from './New_Feature_march_1st.jpg';
import image2 from './Hiring_Poster_18th_Feb.jpg';
import image3 from './January_26th.png';

const newsArticles = [
  {
    id: 1,
    image: image1,
    title: 'Breaking News: Example Topic',
    date: 'February 19, 2025',
    link: '/blog/1', // Link to individual blog page
  },
  {
    id: 2,
    image: image2,
    title: 'Tech News: Example Topic',
    date: 'February 18, 2025',
    link: '/blog/2',
  },
  {
    id: 3,
    image: image3,
    title: 'Sports News: Example Topic',
    date: 'February 17, 2025',
    link: '/blog/3',
  },
];

const NewsSection = () => {
  return (
    <div>
      {/* Title for the News Section */}
      <Typography 
        variant="h4" 
        component="h1"
        sx={{ textAlign: 'center', marginBottom: '20px' }}
      >
        News
      </Typography>
      
      {/* Grid for displaying news articles */}
      <Grid container spacing={2} sx={{ justifyContent: 'center', mb:30 }}>
        {newsArticles.map((article) => (
          <Grid item key={article.id} xs={12} sm={6} md={4} lg={3}>
            <NewsCard {...article} />
          </Grid>
        ))}
      </Grid>
    </div>
  );
};

export default NewsSection;
